<template>
    <div>
        <b-modal
            id="modal-equipmentstepcombo"
            ref="modal"
            size="xl"
            :title="$t('prod_step', { ns: 'production' })"
            :visible="visible && !isMinimized"
            hide-backdrop
            no-close-on-backdrop
            no-close-on-esc
            no-enforce-focus
            hide-header-close
            @hidden="hide"
            @change="change"
        >
        <b-card>
            <steps-insert
                v-if="localSelected != undefined"
                :action="'production/loadLinkedOstData'"
                :paramName="'batchid'"
                :batchid="batchID"
                :recipeid="recipeID"
                :allowInsert="editAllowed"
                standalone
                @input="acceptSteps"
            ></steps-insert>
        </b-card>
        <template v-slot:modal-footer>
            <b-button
                @click="minimize"
                class="bgc_aux_unimportant"
                :title="$t('com_minimize', { ns: 'common' })"
            >
                <font-awesome-icon icon="arrow-down" size="1x" />
            </b-button>
            <b-button @click="closeMe" class="bgc_aux_normal">
                {{ $t('com_close', { ns: 'common' }) }}
            </b-button>
        </template>
        </b-modal>
        <b-button
            v-if="visible && isMinimized"
            @click="restore"
            class="equipment-step-restore bgc_aux_normal"
            :title="$t('com_restore', { ns: 'common' })"
        >
            <font-awesome-icon icon="arrow-up" size="1x" />
        </b-button>
    </div>
</template>

<script>
import StepsInsert from './StepsInsert.vue';
import { EquipmentStepInfo } from '../../models/BakInfo';

const AUTOSAVE_INTERVAL_MS = 15 * 60 * 1000; // 15 minuten

export default {
    name: 'EquipmentStepComboModal',
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        selected: {
            type: EquipmentStepInfo,
            required: true
        },
        editAllowed: {
            type: Boolean,
            default: false
        },
        batchID: {
            type: Number,
            required: false
        },
        recipeID: {
            type: Number,
            default: -1
        },
        refresh: {
            type: Number,
            required: false
        },
        recept: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            isDirty: false,
            changedSteps: [],
            autosaveTimer: null,
            isMinimized: false
        };
    },
    components: {
        StepsInsert
    },
    computed: {
        localSelected() {
            return this.selected;
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.isMinimized = false;
                this.startAutosaveTimer();
            } else {
                this.isMinimized = false;
                this.stopAutosaveTimer();
            }
        }
    },
    methods: {
        acceptSteps(value) {
            this.isDirty = true;
            this.changedSteps = value;
            this.$emit('stepsChanged', value);
        },
        hide() {
            this.$emit('hide');
        },
        change(visible) {
            if (!visible && this.isMinimized) {
                return;
            }
            if (!visible) {
                this.autosave();
            }
            this.$emit('change', visible);
        },
        minimize() {
            this.isMinimized = true;
        },
        restore() {
            this.isMinimized = false;
        },
        // form can only be closed explicitly through this button
        closeMe() {
            this.$bvModal.hide('modal-equipmentstepcombo');
        },
        startAutosaveTimer() {
            this.stopAutosaveTimer();
            this.autosaveTimer = setInterval(
                this.autosave,
                AUTOSAVE_INTERVAL_MS
            );
        },
        stopAutosaveTimer() {
            if (this.autosaveTimer) {
                clearInterval(this.autosaveTimer);
                this.autosaveTimer = null;
            }
        },
        // only saves automatically when there are unsaved changes
        autosave() {
            if (this.isDirty) {
                this.$emit('autosave', this.changedSteps);
                this.isDirty = false;
            }
        }
    },
    mounted() {
        if (this.visible) this.startAutosaveTimer();
    },
    beforeDestroy() {
        this.stopAutosaveTimer();
    }
};
</script>

<style scoped>
.equipment-step-restore {
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    z-index: 1051;
}
</style>
